export function restoreFormDataFromSession(sessionResponses) {
  if (!sessionResponses || typeof sessionResponses !== "object") {
    return null;
  }

  const restoredData = {};

  if (sessionResponses.q1_basic_info) {
    restoredData.userFirstName =
      sessionResponses.q1_basic_info.firstname || null;
    restoredData.userLastName = sessionResponses.q1_basic_info.lastname || null;
    restoredData.userEmail = sessionResponses.q1_basic_info.email || null;
  }

  if (sessionResponses.q2_company_info) {
    restoredData.companyName = sessionResponses.q2_company_info.company || null;
    restoredData.industry = sessionResponses.q2_company_info.industry || null;
  }

  if (sessionResponses.q3_employees) {
    restoredData.companySize =
      sessionResponses.q3_employees.numemployees || null;
  }

  if (sessionResponses.q4_marketing_channels) {
    restoredData.primaryMarketingChannels =
      sessionResponses.q4_marketing_channels.channels || [];
    restoredData.primaryMarketingChannelsOther =
      sessionResponses.q4_marketing_channels.other || null;
    restoredData.q4Score = sessionResponses.q4_marketing_channels.score || 0;
  }

  if (sessionResponses.q5_nurturing) {
    restoredData.nurturingApproach =
      sessionResponses.q5_nurturing.approach || null;
  }

  if (sessionResponses.q6_staffing) {
    restoredData.marketingStaffing =
      sessionResponses.q6_staffing.staffing || null;
  }

  if (sessionResponses.q7_capabilities) {
    restoredData.marketingCapabilities =
      sessionResponses.q7_capabilities.capabilities || [];
    restoredData.q7Score = sessionResponses.q7_capabilities.score || 0;
  }

  if (sessionResponses.q8_goals) {
    restoredData.topMarketingGoals = sessionResponses.q8_goals.goals || [];
  }

  if (sessionResponses.q9_pain_points) {
    restoredData.marketingPainPoints =
      sessionResponses.q9_pain_points.painPoints || [];
  }

  if (sessionResponses.privacy_consent) {
    restoredData.privacyConsent = sessionResponses.privacy_consent;
  }

  return restoredData;
}

export function getResumePageFromSession(currentPage) {
  if (!currentPage || currentPage < 2) {
    return "name";
  }

  const pageMap = {
    2: "name-success",
    3: "company-name",
    4: "company-size",
    5: "marketing-channel",
    6: "nurturing-approach",
    7: "marketing-staffing",
    8: "marketing-capabilities",
    9: "top-goals",
    10: "marketing-pain-points",
    11: "privacy-send",
  };

  return pageMap[currentPage] || "name";
}
